{
  "pt": {
    "issue": {
      "actions": {
        "approve_for_customer": "Aprovar para o cliente",
        "cancel_approval": "Cancelar a aprovação do cliente",
        "collapse": "Recolher os defeitos",
        "create_category": "Adicionar nova categoria",
        "create_issue": "Criar defeito",
        "create_issue_customer": "Comunicar defeito",
        "delete": "Eliminar o defeito",
        "expand": "Expandir os defeitos",
        "export_images": "Descarregar imagens",
        "hideActivity": "Ocultar atividade",
        "hideDetails": "Ocultar detalhes",
        "openConversation": "Abrir conversa",
        "reject_for_customer": "Rejeitar para o cliente",
        "request_approval": "Solicitar a aprovação do cliente",
        "show": "Mostrar defeito",
        "showActivity": "Mostrar atividade",
        "showDetails": "Mostrar detalhes",
        "startConversation": "Iniciar conversa",
        "start_conversation": "Iniciar conversa sobre este defeito",
        "undo_customer_approval": "Anular a aprovação do cliente",
        "undo_customer_rejection": "Anular a rejeição do cliente",
        "update": "Atualizar defeitos"
      },
      "attributes": {
        "approval_status": "Estado de aprovação",
        "assignee": "Responsável",
        "category": "Categoria",
        "created_at": "Criado",
        "deadline": "Prazo",
        "description": "Descrição",
        "issue_list_type": "Lista de defeitos",
        "name": "Nome",
        "responsible": "Responsável",
        "status": "Estado",
        "statuses": {
          "approval_not_requested": "Aprovação Não Solicitada",
          "approval_requested": "Aprovação Solicitada",
          "approved": "Aprovado",
          "completed": "Concluído",
          "created": "Aberto",
          "declined": "Recusado",
          "inbox": "Enviado",
          "not_completed": "Não concluído",
          "ongoing": "Em curso"
        },
        "updated_at": "Última atualização"
      },
      "edit_actions": {
        "edit_category": "Categoria",
        "edit_deadline": "Prazo",
        "edit_issue_list_type": "Lista de defeitos",
        "edit_responsible": "Responsável",
        "edit_status": "Estado"
      },
      "labels": {
        "activity": "Atividade",
        "addImagesSubtitle": "Uma imagem diz mais do que mil palavras",
        "addImagesTitle": "Adicionar imagens para nos ajudar a compreender ainda melhor o defeito",
        "after_care_page_title": "Os seus defeitos",
        "all_categories_can_be_managed_under": "Todas as categorias podem ser geridas em",
        "approvalNotRequested": "Aprovação não solicitada",
        "approvalRequested": "Aprovação solicitada",
        "approved": "Aprovado",
        "approvedInfo": "O cliente aprovou este defeito",
        "assignee": "Responsável",
        "cancelCustomerApproval": "Cancelar a aprovação do cliente",
        "collapse": "Ocultar atividade",
        "company_settings": "definições da organização",
        "count_edit": "Editar defeito | Editar {count} defeitos",
        "create_new_category?": "Não encontra a categoria de que necessita? Crie uma nova!",
        "created_at": "Criado em",
        "customerApproved": "Aprovado pelo cliente",
        "customerRejected": "Rejeitado pelo cliente",
        "deadline_date": "Prazo",
        "description": "Descrição",
        "descriptionSubtitle": "Utilizar marcadores e frases curtas para facilitar a compreensão do defeito",
        "descriptionTitle": "Dar uma breve descrição",
        "edit_category": "Editar categoria",
        "edit_issue": "Editar defeito",
        "isThisPointFixed": "Está fixo, na sua opinião?",
        "issue_category_name": "Categoria",
        "issue_status_name": "Estado",
        "issues_clear_selection": "Limpar seleção",
        "issues_select_all_pages": "Selecionar todos os {total} defeitos",
        "issues_select_one": "Selecione pelo menos 1 defeito",
        "issues_selected": "defeitos selecionados",
        "issues_selected_all_pages": "Todos os {total} defeitos selecionados",
        "issues_selected_count": "{selected} defeito selecionado | {selected} defeitos selecionados",
        "name": "Nome",
        "new": "Criar novo defeito",
        "new_category": "Nova categoria",
        "noDescriptionYet": "Ainda não há descrição",
        "no_issue_deadline": "Sem prazo definido",
        "no_issues": "Sem defeitos",
        "no_responsible": "Não responsável",
        "origin": "Origem",
        "reason": "Motivo",
        "redoRequest": "Refazer pedido",
        "requestCustomerApproval": "Solicitar a aprovação do cliente",
        "requested": "Solicitado",
        "requestedInfo": "Aprovação do cliente solicitada",
        "resetRequest": "Repor pedido",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsável",
        "return_to_overview": "Voltar",
        "showIssuesfor": "Mostrar defeitos para",
        "statusExplained": "O que significa cada cor de estado",
        "subjectSubtitle": "Só é necessário 1 relatório por defeito. Nós tratamos do resto",
        "subjectTitle": "Descreva o defeito em poucas palavras",
        "undoCustomerApproved": "Anular a aprovação do cliente",
        "unit_issues_will_be_shown_here": "Todas as unidades que constam da lista de defeitos serão mostradas aqui",
        "unit_name": "Nome da unidade",
        "updated_at": "Última atualização",
        "waitingForApproval": "Este ponto tem de ser aceite pelo cliente antes de se poder iniciar uma conversa",
        "whyIsThisPointNotFixed": "Porque é que este defeito não está fixo?",
        "youApprovedThisPoint": "Fixo, na sua opinião",
        "youRejectedThisPoint": "Não fixo, na sua opinião"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Será notificado se for comunicado um novo defeito.",
            "title": "Ainda não foram comunicados defeitos para a sua unidade"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Quando os clientes criarem novos defeitos, estes serão novamente apresentados aqui.",
            "title": "Processou todos os defeitos recebidos dos clientes"
          },
          "none": {
            "subtitle": "Começar a registar o que deve ser corrigido ou melhorado",
            "title": "Criar o seu primeiro defeito"
          },
          "overview": {
            "subtitle": "Crie o seu primeiro defeito dentro de uma unidade para começar",
            "title": "Os defeitos criados em todas as suas unidades serão mostrados aqui"
          },
          "unit": {
            "title": "Todos os defeitos para esta unidade serão mostrados aqui"
          }
        },
        "partners": {
          "none": {
            "subtitle": "A partir do momento em que lhe são atribuídos defeitos, estes serão visíveis aqui",
            "title": "Ainda não lhe foram atribuídos defeitos"
          }
        }
      },
      "sortGroups": {
        "date": "Data",
        "deadline": "Prazo",
        "name": "Nome"
      },
      "toasts": {
        "update": "Defeito atualizado"
      },
      "validation": {
        "issue_list_type_required": "É necessária uma lista de defeitos",
        "pleaseProvideAReason": "Indique um motivo",
        "status_required": "O estado é necessário"
      }
    }
  }
}
